export const filterKeys = {
  site: [
    "siteId",
    "siteName",
    "addressOne",
    "addressTwo",
    "city",
    "postalCode",
    "state",
    "country",
  ],
  structure: [
    "structureId",
    "structureName",
    "structureAddressOne",
    "structureAddressTwo",
    "structureCity",
    "structurePostalCode",
    "structureState",
    "structureCountry",
  ],
  circuit: ["circuitVendorId"],
};
